export var Fasting;
(function (Fasting) {
    Fasting["NOT_REQUIRED"] = "notRequired";
    Fasting["REQUIRED"] = "required";
})(Fasting || (Fasting = {}));
export var CollectionDate;
(function (CollectionDate) {
    CollectionDate["ANY"] = "any";
    CollectionDate["ON"] = "on";
    CollectionDate["BEFORE"] = "before";
    CollectionDate["AFTER"] = "after";
    CollectionDate["BETWEEN"] = "between";
})(CollectionDate || (CollectionDate = {}));
export var CollectionTime;
(function (CollectionTime) {
    CollectionTime["ANY"] = "any";
    CollectionTime["AM"] = "am";
    CollectionTime["PM"] = "pm";
})(CollectionTime || (CollectionTime = {}));
export var OrderParty;
(function (OrderParty) {
    OrderParty["PATIENT"] = "patient";
    OrderParty["OFFICE"] = "office";
})(OrderParty || (OrderParty = {}));
export var OrderFormat;
(function (OrderFormat) {
    OrderFormat["CSV"] = "csv";
    OrderFormat["MANUAL"] = "manual";
    OrderFormat["PDF"] = "pdf";
})(OrderFormat || (OrderFormat = {}));
//# sourceMappingURL=orderSettings.js.map